import pathfinder from '@fiverr-private/pathfinder';
import { formatQueryParams, getCategorySlug, getNestedSubCategorySlug, getSubCategorySlug } from '../helperFunctions';
import { PATHFINDER, PATHS } from '../constants';
import type { MapperItemConfig } from './types';

export const getStaticPagePath = ({
    categoryId,
    id,
    nestedSubCategoryId,
    filterUid,
    queryParams,
}: MapperItemConfig) => {
    if (!(categoryId && id && filterUid)) {
        return PATHS.ROOT;
    }

    if (
        isNaN(parseInt(categoryId, 10)) ||
        isNaN(parseInt(id, 10)) ||
        (nestedSubCategoryId && isNaN(parseInt(nestedSubCategoryId, 10)))
    ) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId);
    const subCategorySlug = getSubCategorySlug(id);

    let params: Record<string, any> = {
        category_id: categorySlug,
        id: subCategorySlug,
        filters_uid: filterUid,
    };

    if (nestedSubCategoryId) {
        const nestedSubCategorySlug = getNestedSubCategorySlug(nestedSubCategoryId, id);

        params = {
            ...params,
            nested_sub_category_id: nestedSubCategorySlug,
        };

        return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY_STATIC_PAGE, params, formatQueryParams());
    }

    return pathfinder(PATHFINDER.SUB_CATEGORY_STATIC_PAGE, params, formatQueryParams({ queryParams }));
};
